import { render, staticRenderFns } from "./MapHomeBtn.vue?vue&type=template&id=f3f6b146&scoped=true"
import script from "./MapHomeBtn.vue?vue&type=script&lang=js"
export * from "./MapHomeBtn.vue?vue&type=script&lang=js"
import style0 from "./MapHomeBtn.vue?vue&type=style&index=0&id=f3f6b146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f6b146",
  null
  
)

export default component.exports